"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgClientState = void 0;
var ow_1 = __importDefault(require("ow"));
var codecimpl_1 = require("../../../../cosmos/v1beta1/codec/generated/codecimpl");
var typeurl_1 = require("../../../common/constants/typeurl");
var ow_types_1 = require("../../ow.types");
exports.msgClientState = function () {
    return (function () {
        function ClientState(options) {
            ow_1.default(options, 'options', ow_types_1.owClientStateOptions);
            this.chainId = options.chainId;
            this.trustLevel = options.trustLevel;
            this.trustingPeriod = options.trustingPeriod;
            this.unbondingPeriod = options.unbondingPeriod;
            this.maxClockDrift = options.maxClockDrift;
            this.frozenHeight = options.frozenHeight;
            this.latestHeight = options.latestHeight;
            this.proofSpecs = options.proofSpecs;
            this.upgradePath = options.upgradePath;
            this.allowUpdateAfterExpiry = options.allowUpdateAfterExpiry;
            this.allowUpdateAfterMisbehaviour = options.allowUpdateAfterMisbehaviour;
        }
        ClientState.prototype.getEncoded = function () {
            var clientStateOptions = {
                chainId: this.chainId,
                trustLevel: this.trustLevel,
                trustingPeriod: this.trustingPeriod,
                unbondingPeriod: this.unbondingPeriod,
                maxClockDrift: this.maxClockDrift,
                frozenHeight: this.frozenHeight,
                latestHeight: this.latestHeight,
                proofSpecs: this.proofSpecs,
                upgradePath: this.upgradePath,
                allowUpdateAfterExpiry: this.allowUpdateAfterExpiry,
                allowUpdateAfterMisbehaviour: this.allowUpdateAfterMisbehaviour,
            };
            var clientStateWrapped = codecimpl_1.ibc.lightclients.tendermint.v1.ClientState.create(clientStateOptions);
            return codecimpl_1.google.protobuf.Any.create({
                type_url: typeurl_1.COSMOS_MSG_TYPEURL.ibc.LightClients.ClientState,
                value: codecimpl_1.ibc.lightclients.tendermint.v1.ClientState.encode(clientStateWrapped).finish(),
            });
        };
        ClientState.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.ibc.LightClients.ClientState,
                value: {
                    chainId: this.chainId,
                    trustLevel: this.trustLevel,
                    trustingPeriod: this.trustingPeriod,
                    unbondingPeriod: this.unbondingPeriod,
                    maxClockDrift: this.maxClockDrift,
                    frozenHeight: this.frozenHeight,
                    latestHeight: this.latestHeight,
                    proofSpecs: this.proofSpecs,
                    upgradePath: this.upgradePath,
                    allowUpdateAfterExpiry: this.allowUpdateAfterExpiry,
                    allowUpdateAfterMisbehaviour: this.allowUpdateAfterMisbehaviour,
                },
            };
        };
        ClientState.prototype.toRawAminoMsg = function () {
            throw new Error('IBC Module not supported under amino encoding scheme');
        };
        ClientState.fromCosmosMsgJSON = function (_msgJsonStr) {
            throw new Error('IBC Module does not support JSON decoding.');
        };
        return ClientState;
    }());
};
//# sourceMappingURL=ClientState.js.map